// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — RackGroup.classic.js, новая — RackGroup.cp.js
import { isCp } from 'libs/design';
import * as classic from './RackGroup.classic';
import * as cp from './RackGroup.cp';

export default isCp ? cp.default : classic.default;
